import { Button, FlyoutButton, Icon, Spinner } from '@acpaas-ui/react-components';
import _ from 'lodash';
import FlyoutContentList from '../../core/FlyoutContentList';
import ActivityItemMeta from '../ActivityItemMeta';
import CommentForm from './CommentForm';

const CommentItem = ({
  onCommentAction,
  updatingCommentId,
  id,
  author,
  createdAt,
  text,
  mentions = [],
  pinned,
  pinnedBy,
  deleted,
  commentEditForm,
  firstPinned,
  currentUser
}) => {
  const isEditing = commentEditForm?.data?.id === id;

  const parseMentions = (text) => {
    let parsed = text;

    mentions.forEach((mention) => {
      parsed = parsed.replace(`@${mention.name}`, `<span class="mention">@${mention.name}</span>`);
    });

    return parsed;
  };

  return (
    <div
      className={`spo-m-dossier-sidebar-comment__item ${pinned ? 'spo-m-dossier-sidebar-comment__item--pinned' : ''}`}
    >
      {firstPinned && <Icon name="ai-pin-1" className="u-text-danger u-margin-bottom-xs u-margin-top-xs" />}
      <ActivityItemMeta
        user={author}
        userFullName={`${author?.firstName} ${author?.lastName}`.trim()}
        userAvatarUrl={author.avatarUrl}
        date={createdAt}
        pinnedBy={pinned ? pinnedBy : undefined}
        isUpdating={updatingCommentId === id}
        flyoutMenu={
          !deleted && (
            <FlyoutButton
              size="small"
              icon="ai-navigation-menu-vertical"
              transparent
              flyoutSize="small"
              flyoutDirection="right"
              ariaLabel="Open flyout"
              disabled={updatingCommentId}
            >
              <FlyoutContentList
                items={[
                  pinned ? { value: 'unpin', label: 'Losmaken' } : { value: 'pin', label: 'Vastzetten' },
                  currentUser?.userName === author?.userName && { value: 'delete', label: 'Verwijderen' },
                  currentUser?.userName === author?.userName && { value: 'edit', label: 'Wijzigen' }
                ].filter((action) => !!action)}
                onSelect={(payload) => onCommentAction(payload?.value, id)}
              />
            </FlyoutButton>
          )
        }
      />
      <div className={`spo-m-dossier-sidebar-comment__item-body ${isEditing ? 'editing' : ''}`}>
        {isEditing ? (
          <>
            <CommentForm
              borderless
              editMode
              text={commentEditForm?.data?.text}
              data={commentEditForm?.data}
              submitting={commentEditForm?.isSubmitting}
              onInput={commentEditForm?.input}
              disabled={text === commentEditForm?.data?.text}
              onEditCancel={() => onCommentAction('editCancel', id)}
              onEditSubmit={() => onCommentAction('editSubmit', id)}
            />
          </>
        ) : deleted ? (
          <em className="u-text-light">Deze commentaar werd verwijderd.</em>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: parseMentions(text || '') }}></div> ?? ''
        )}
      </div>
    </div>
  );
};

export default CommentItem;
